// Ship's Papers — extract a PDF's text in the browser at upload time (pdf.js) so
// documents are searchable by content. Best-effort: scanned PDFs yield nothing,
// images yield nothing, failures yield null. Never called for Crew & People.
//
// Every call destroys its loading task, success or failure: each getDocument
// spins up a pdf.js worker, and an undestroyed one stays alive with the file's
// bytes for as long as the page is open — one per upload.
export async function extractPdfText(file: File, maxChars = 200_000, maxPages = 60): Promise<string | null> {
  if (file.type !== 'application/pdf') return null;
  let task: { destroy: () => Promise<void> } | null = null;
  try {
    const pdfjs = await import('pdfjs-dist');
    // Worker script served from our own bundle (CSP-safe).
    pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();
    const loading = pdfjs.getDocument({ data: await file.arrayBuffer(), disableFontFace: true });
    task = loading;
    const doc = await loading.promise;
    const parts: string[] = [];
    let total = 0;
    for (let p = 1; p <= Math.min(doc.numPages, maxPages) && total < maxChars; p++) {
      const page = await doc.getPage(p);
      const content = await page.getTextContent();
      const text = content.items.map((it) => ('str' in it ? it.str : '')).join(' ').replace(/\s+/g, ' ').trim();
      if (text) { parts.push(text); total += text.length; }
    }
    const out = parts.join('\n').slice(0, maxChars).trim();
    return out || null;
  } catch {
    return null;
  } finally {
    // Destroying the task destroys its document and terminates the worker.
    if (task) await task.destroy().catch(() => undefined);
  }
}
